import { Start, Stop } from 'smg/buttons';
import { CreateContact } from 'smg/customer-api/contact';
import { ReportValidity } from 'smg/form';
import { Phone } from 'smg/phone';
import { Uploader } from 'smg/uploads';
import { Relref } from '../hugo';

main();

function main() {
    const $form = document.querySelector('#contact-form') as HTMLFormElement;
    const $fieldset = $form.querySelector('fieldset') as HTMLFieldSetElement;

    const $reason = $form.querySelector('#reason') as HTMLSelectElement;
    const $firstName = $form.querySelector('#first-name') as HTMLInputElement;
    const $lastName = $form.querySelector('#last-name') as HTMLInputElement;
    const $email = $form.querySelector('#email') as HTMLInputElement;
    const $phone = $form.querySelector('#phone') as HTMLInputElement;
    const $message = $form.querySelector('#message') as HTMLTextAreaElement;
    const $uploadsLabel = $form.querySelector('#uploads') as HTMLLabelElement;
    const $submit = $form.querySelector('[type="submit"]') as HTMLButtonElement;

    const p = new Phone($phone);

    const u = new Uploader($uploadsLabel, {
        confirmBtn: $submit,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    $form.noValidate = true;
    $form?.addEventListener('submit', e => {
        e.preventDefault();

        if (!ReportValidity($form)) {
            return;
        }

        $fieldset.setAttribute('disabled', 'disabled');
        Start($submit);

        CreateContact({
            name: `${$firstName.value} ${$lastName.value}`,
            company: '',
            phone: p,
            email: $email.value,
            content: `Reason: ${$reason.value}/n/n ${$message.value}`,
            uploader: u,
            $reCaptchaPlaceholder: document.querySelector('.contact-recaptcha-parent') as HTMLElement,
        }).then(() => {
            window.location.href = Relref('/');
        }).catch(err => {
            console.error(err);
            $fieldset.removeAttribute('disabled');
            Stop($submit);
        });
    });
}